import { styled } from '@mui/material/styles'

export const SearchWrapper = styled('div')({
  width: '100%',
})
